import { TruckMinusOutlineIcon } from './TruckMinusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 583767E2-4272-4483-99B5-5677E6EAB027
 * name truck-minus-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-minus-outline.svg
 * tags
 * - Transportation + Road 
 */
export const TruckSubtractOutlineIcon = TruckMinusOutlineIcon;
export default TruckSubtractOutlineIcon